import { render, staticRenderFns } from "./JsNavigationButton.vue?vue&type=template&id=46ee21f4"
import script from "./JsNavigationButton.vue?vue&type=script&lang=ts"
export * from "./JsNavigationButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports